import * as IntroFns from '../utilities/IntroFns';
import ShowCards from './ShowCards';

function App(props) {

  var selectNew = props.selectNew;
  var setIsShowingPrevious = props.setIsShowingPrevious;
  var itemCategories = props.itemCategories;
  var itemType = props.itemType;

  function clickOption(anOption){
    return function(e) {
      if (!anOption.i){
        var code = IntroFns.baseCode();
        selectNew(-1, code);
      }else{
        setIsShowingPrevious(anOption.i);
      }
      // body...
    }
  }
  var options = [{n:'Empty dApp', a:'gg:website', i:false}].concat(IntroFns.actualOptions(itemCategories, itemType)); 

  return <ShowCards options={options} clickOption={clickOption} />
//

//
}

export default App;
